import React, { useState, useEffect } from "react";

export default function HomePage() {
  const [currentDateTime, setCurrentDateTime] = useState("");

  useEffect(() => {
    const updateDateTime = () => {
      const date = new Date();
      setCurrentDateTime(date.toLocaleString()); 
    };

    const interval = setInterval(updateDateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg my-8">
      <div className="mb-6 text-center text-lg text-gray-700">
        {/* <p>{currentDateTime}</p> */}
      </div>

      <h2 className="text-2xl font-bold mb-4">📋 How It Works</h2>
      <ol className="list-disc pl-5 text-lg space-y-1">
           <li>📌 Clock your attendance daily from the attendance page.</li>
            <li>📝 Submit your daily internship reports under the "Submit Report" section.</li>
            <li>📂 View the status of your submitted reports anytime.</li>
            <li>✅ Approved reports help track your internship progress.</li>
            
          </ol>
     
      <div className="mt-6 p-4 bg-blue-50 rounded">
        <h3 className="font-semibold mb-2">✅ Tips:</h3>
        <ul className="list-disc list-inside space-y-1 text-sm text-gray-600">
          <li>Be detailed and clear in your reports.</li>
          <li>Check teacher feedback carefully.</li>
          <li>Stay consistent by submitting daily!</li>
        </ul>
      </div>
    </div>
  );
}
